/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LeadContextEntity } from '../models/LeadContextEntity';
import type { LeadEntity } from '../models/LeadEntity';
import type { LeadStatisticsDto } from '../models/LeadStatisticsDto';
import type { OutreachEntity } from '../models/OutreachEntity';
import type { PostLeadDto } from '../models/PostLeadDto';
import type { RegenerateOutreachContentDto } from '../models/RegenerateOutreachContentDto';
import type { SendScheduledOutreachJobEntity } from '../models/SendScheduledOutreachJobEntity';
import type { UpdateOutreachDto } from '../models/UpdateOutreachDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SalesAdminService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Create a new Lead
     * @param requestBody
     * @returns LeadEntity Lead created successfully
     * @throws ApiError
     */
    public salesAdminControllerCreateLeadV1(
        requestBody: PostLeadDto,
    ): CancelablePromise<LeadEntity> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/sales/lead',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get all Leads
     * @returns LeadEntity Leads retrieved successfully
     * @throws ApiError
     */
    public salesAdminControllerGetLeadsV1(): CancelablePromise<Array<LeadEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/sales/lead',
        });
    }
    /**
     * Get a Lead
     * @param leadId
     * @returns LeadEntity Lead retrieved successfully
     * @throws ApiError
     */
    public salesAdminControllerGetLeadByIdV1(
        leadId: string,
    ): CancelablePromise<LeadEntity> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/sales/lead/{leadId}',
            path: {
                'leadId': leadId,
            },
            errors: {
                404: `Lead not found`,
            },
        });
    }
    /**
     * Delete a Lead
     * @param leadId
     * @returns any
     * @throws ApiError
     */
    public salesAdminControllerDeleteLeadV1(
        leadId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v1/sales/lead/{leadId}',
            path: {
                'leadId': leadId,
            },
        });
    }
    /**
     * Update an Outreach
     * @param outreachId
     * @param requestBody
     * @returns OutreachEntity Outreach updated successfully
     * @throws ApiError
     */
    public salesAdminControllerUpdateOutreachV1(
        outreachId: string,
        requestBody: UpdateOutreachDto,
    ): CancelablePromise<OutreachEntity> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/sales/outreach/{outreachId}',
            path: {
                'outreachId': outreachId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Outreach not found`,
            },
        });
    }
    /**
     * Delete an Outreach
     * @param outreachId
     * @returns any
     * @throws ApiError
     */
    public salesAdminControllerDeleteOutreachV1(
        outreachId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v1/sales/outreach/{outreachId}',
            path: {
                'outreachId': outreachId,
            },
        });
    }
    /**
     * Get the scheduled job for an Outreach
     * @param outreachId
     * @returns SendScheduledOutreachJobEntity Outreach job retrieved successfully
     * @throws ApiError
     */
    public salesAdminControllerGetOutreachJobV1(
        outreachId: string,
    ): CancelablePromise<SendScheduledOutreachJobEntity> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/sales/outreach/{outreachId}/job',
            path: {
                'outreachId': outreachId,
            },
            errors: {
                404: `Outreach or job not found`,
            },
        });
    }
    /**
     * Get Outreaches for a Lead
     * @param leadId
     * @returns OutreachEntity Outreaches retrieved successfully
     * @throws ApiError
     */
    public salesAdminControllerGetOutreachesByLeadIdV1(
        leadId: string,
    ): CancelablePromise<Array<OutreachEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/sales/lead/{leadId}/outreach',
            path: {
                'leadId': leadId,
            },
            errors: {
                404: `Outreach not found for this Lead`,
            },
        });
    }
    /**
     * Get Contexts for a Lead
     * @param leadId
     * @returns LeadContextEntity Contexts retrieved successfully
     * @throws ApiError
     */
    public salesAdminControllerGetLeadContextsByLeadIdV1(
        leadId: string,
    ): CancelablePromise<Array<LeadContextEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/sales/lead/{leadId}/context',
            path: {
                'leadId': leadId,
            },
            errors: {
                404: `Lead has not been found`,
            },
        });
    }
    /**
     * Get all Pulse jobs for Sales
     * @returns SendScheduledOutreachJobEntity The Pulse jobs for sales have been returned
     * @throws ApiError
     */
    public salesAdminControllerGetPulseSalesJobsV1(): CancelablePromise<Array<SendScheduledOutreachJobEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/sales/pulseSalesJobs',
        });
    }
    /**
     * Get lead statistics
     * @returns LeadStatisticsDto Lead statistics retrieved successfully
     * @throws ApiError
     */
    public salesAdminControllerGetLeadStatisticsV1(): CancelablePromise<LeadStatisticsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/sales/statistics',
        });
    }
    /**
     * Regenerate outreach content based on feedback
     * @param outreachId
     * @param requestBody
     * @returns OutreachEntity Outreach content regenerated successfully
     * @throws ApiError
     */
    public salesAdminControllerRegenerateOutreachContentV1(
        outreachId: string,
        requestBody: RegenerateOutreachContentDto,
    ): CancelablePromise<OutreachEntity> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/sales/outreach/{outreachId}/regenerate',
            path: {
                'outreachId': outreachId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Outreach not found`,
            },
        });
    }
}
